// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  nominatedBusinessId: __t.string().name("nominated_business_id"),
  intendedInvestmentDollars: __t.u32().name("intended_investment_dollars"),
  reason: __t.option(__t.string()),
  firstName: __t.option(__t.string()).name("first_name"),
  lastName: __t.option(__t.string()).name("last_name"),
  consentToDisplay: __t.option(__t.bool()).name("consent_to_display"),
});
